import { FunctionComponent } from 'react';
import { ListProps } from 'react-admin';
import AppList from '../../Components/ui/detail/AppList';
import { AppAutocompleteInput, AppSelectInput } from '../../Components/ui/input';
import AppListFilter from '../../Components/ui/layout/AppListFilter';
import AppTitle from '../../Components/ui/layout/AppTitle';
import { REVIEW_RATING_CHOICES } from './constants';
import ReviewDatagrid from './ReviewDatagrid';

const ReviewListFilters = (
  <AppListFilter>
    <AppSelectInput source="rating" label="Valutazione" choices={REVIEW_RATING_CHOICES} md={2} />
    <AppAutocompleteInput
      label="Autore"
      source="fkPresenter"
      resettable
      reference="participants"
      optionText={(p) => {
        if (!p) return '';
        if (p.type === 'company') return p.businessName;
        return `${p.firstName} ${p.lastName}`;
      }}
      md={3}
    />
    <AppAutocompleteInput
      label="Destinatario"
      source="recipientId"
      resettable
      reference="people"
      optionText={(p) => {
        if (!p) return '';
        if (p.type === 'company') return p.businessName;
        return `${p.firstName} ${p.lastName}`;
      }}
      md={3}
    />
    <AppAutocompleteInput
      label="Lotto"
      source="itemId"
      resettable
      reference="items"
      optionText="title"
      md={3}
    />
  </AppListFilter>
);

const ReviewList: FunctionComponent<ListProps> = (props) => {
  return (
    <AppList
      {...props}
      title={<AppTitle title="Recensioni" />}
      filters={ReviewListFilters}
      hideCreateButton
    >
      <ReviewDatagrid rowClick="show" />
    </AppList>
  );
};

export default ReviewList;
